<template>
  <div>
    <v-card tile flat>
      <v-toolbar :style="styles" dark flat>
        <v-toolbar-title class="white--text text-center"
          >Share with</v-toolbar-title
        >
        <template v-slot:extension>
          <v-tabs v-model="tab" style="background: rgba(0, 0, 0, 0.2)">
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab href="#portal-sharing-applicants">Applicants</v-tab>
            <v-tab href="#portal-sharing-viewers">Viewers</v-tab>
            <v-tab href="#portal-sharing-sent">Sent</v-tab>
          </v-tabs>
        </template>
        <v-spacer></v-spacer>
        <v-switch
          hide-details
          class="my-0 pull-right"
          :true-value="1"
          :false-value="0"
          :label="item.active === 1 ? 'Active' : 'Paused'"
          v-model="item.active"
          @change="onChange"
        ></v-switch>
      </v-toolbar>

      <v-tabs-items v-model="tab">
        <v-tab-item value="portal-sharing-applicants">
          <v-container style="height: 350px; overflow-y: auto">
            <v-overlay
              :absolute="true"
              :opacity="0.8"
              :value="item.active === 0"
            >
              <v-icon>fa-eye-slash</v-icon>
            </v-overlay>
            <v-row justify="center" align="center">
              <v-col class="text-right" cols="9">
                <span class="text--secondary">
                  Preview what
                  <b>applicants</b> will see
                </span>
              </v-col>
              <v-col class="text-center" cols="3">
                <v-btn fab :href="applicationLink" target="_blank">
                  <v-icon>fa-eye</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="9">
                <v-text-field
                  label="Link to portal"
                  outlined
                  hide-details
                  :value="applicationLink"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="3" class="text-center py-0">
                <v-btn fab dark color="green" v-if="copied.applicant">
                  <span class="caption">Copied</span>
                </v-btn>
                <v-btn
                  title="Copy to clipboard"
                  fab
                  v-else
                  v-clipboard:copy="applicationLink"
                  v-clipboard:success="onCopyApplicant"
                  v-clipboard:error="onErrorApplicant"
                >
                  <v-icon>fa-paperclip</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="9">
                <v-form
                  ref="applicant-access-code-form"
                  autocomplete="applicant-access-code"
                  lazy-validation
                >
                  <v-text-field
                    outlined
                    :label="
                      item.settings.applicants.access_code
                        ? 'Access code'
                        : 'Access code (not required)'
                    "
                    v-model="item.settings.applicants.access_code"
                    placeholder="Set an access code for applicants"
                    type="text"
                    @change="onApplicantAccessCode"
                    autocomplete="applicant-access-code"
                    hide-details
                  ></v-text-field>
                </v-form>
              </v-col>
              <v-col cols="3" class="text-center">
                <v-btn
                  @click="save"
                  fab
                  dark
                  color="green"
                  v-if="modified_access_code.applicant"
                >
                  <span class="caption">Save</span>
                </v-btn>
                <div v-else>
                  <v-icon v-if="item.settings.applicants.access_code"
                    >fa-lock</v-icon
                  >
                  <v-icon v-else>fa-lock-open</v-icon>
                </div>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="9" class="text-center">
                <v-text-field
                  outlined
                  label="Send email"
                  placeholder="Applicant email address"
                  hide-details
                  v-model="email.applicant"
                ></v-text-field>
              </v-col>
              <v-col cols="3" class="text-center py-0">
                <v-btn fab dark color="green" v-if="sent.applicant">
                  <span class="caption">Sent</span>
                </v-btn>
                <v-btn
                  fab
                  :disabled="modified_access_code.applicant"
                  v-else
                  @click="sendApplicant"
                  :loading="sending"
                >
                  <v-icon small>fa-paper-plane</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item value="portal-sharing-viewers">
          <v-container style="height: 350px; overflow-y: auto">
            <v-overlay
              :absolute="true"
              :opacity="0.8"
              :value="item.active === 0"
            >
              <v-icon>fa-eye-slash</v-icon>
            </v-overlay>
            <v-row justify="center" align="center">
              <v-col class="text-right" cols="9">
                <span class="text--secondary">
                  Preview what
                  <b>viewers</b> will see
                </span>
              </v-col>
              <v-col class="text-center" cols="3">
                <v-btn fab :href="viewerLink" target="_blank">
                  <v-icon>fa-eye</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="9">
                <v-text-field
                  label="Link to portal"
                  outlined
                  hide-details
                  :value="viewerLink"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="3" class="text-center py-0">
                <v-btn fab dark color="green" v-if="copied.viewer">
                  <span class="caption">Copied</span>
                </v-btn>
                <v-btn
                  title="Copy to clipboard"
                  fab
                  v-else
                  v-clipboard:copy="viewerLink"
                  v-clipboard:success="onCopyViewer"
                  v-clipboard:error="onErrorViewer"
                >
                  <v-icon>fa-paperclip</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="9">
                <v-form
                  ref="viewer-access-code-form"
                  autocomplete="viewer-access-code"
                  lazy-validation
                >
                  <v-text-field
                    outlined
                    :label="
                      item.settings.viewers.access_code
                        ? 'Access code'
                        : 'Access code (not required)'
                    "
                    v-model="item.settings.viewers.access_code"
                    placeholder="Set an access code for viewers"
                    type="text"
                    @change="onViewerAccessCode"
                    autocomplete="viewer-access-code"
                    hide-details
                  ></v-text-field>
                </v-form>
              </v-col>
              <v-col cols="3" class="text-center">
                <v-btn
                  @click="save"
                  fab
                  dark
                  color="green"
                  v-if="modified_access_code.viewer"
                >
                  <span class="caption">Save</span>
                </v-btn>
                <div v-else>
                  <v-icon v-if="item.settings.viewers.access_code"
                    >fa-lock</v-icon
                  >
                  <v-icon v-else>fa-lock-open</v-icon>
                </div>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="9" class="text-center">
                <v-text-field
                  outlined
                  label="Send email"
                  placeholder="Viewer email address"
                  hide-details
                  v-model="email.viewer"
                ></v-text-field>
              </v-col>
              <v-col cols="3" class="text-center py-0">
                <v-btn fab dark color="green" v-if="sent.viewer">
                  <span class="caption">Sent</span>
                </v-btn>
                <v-btn
                  fab
                  :disabled="modified_access_code.viewer"
                  v-else
                  @click="sendViewer"
                  :loading="sending"
                >
                  <v-icon small>fa-paper-plane</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>

        <v-tab-item value="portal-sharing-sent">
          <v-container style="height: 350px; overflow-y: auto">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Email</th>
                    <th class="text-left">Type</th>
                    <th
                      class="text-right clicky"
                      @click="sort_invites = !sort_invites"
                    >
                      Date
                      <v-icon x-small v-if="sort_invites"
                        >fa-chevron-down</v-icon
                      >
                      <v-icon x-small v-else>fa-chevron-up</v-icon>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in sent_invites" :key="item.id">
                    <td>{{ item.email }}</td>
                    <td>
                      <span v-if="item.template === 'invite-viewer'"
                        >Viewer</span
                      >
                      <span v-if="item.template === 'invite-applicant'"
                        >Applicant</span
                      >
                      <span v-if="item.template === 'invite-library'"
                        >Library</span
                      >
                    </td>
                    <td class="text-right">{{ item.date_added | fromNow }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "PortalSharing",
  props: ["value", "styles"],
  data() {
    return {
      sent_invites: [],
      sort_invites: false,
      sending: false,
      tab: "portal-sharing-applicants",
      copied: { applicant: false, viewer: false },
      sent: { applicant: false, viewer: false },
      modified_access_code: {
        applicant: false,
        viewer: false,
      },
      email: {
        applicant: "",
        viewer: "",
      },
      show: {
        applicant_access_code: false,
        viewer_access_code: false,
      },
    };
  },
  computed: {
    item() {
      return this.value;
    },
    applicationLink() {
      return `${window.location.origin}/applicant-link/${this.item.applicant_uid}`;
    },
    viewerLink() {
      return `${window.location.origin}/viewer-link/${this.item.viewer_uid}`;
    },
  },
  created() {
    this.loadSent();
  },
  watch: {
    sort_invites: function () {
      this.sortInvites();
    },
  },
  methods: {
    access_code(v) {
      if (!v) {
        return true;
      }
      if (v) {
        if (v.length < 5) {
          return "Min 5 characters";
        }
      }
      return true;
    },
    async loadSent() {
      try {
        this.sent_invites = await this.$api(`/user/invites/${this.item.id}`);
        this.sortInvites();
      } catch (ex) {
        alert(ex.error);
      }
    },

    sortInvites() {
      this.sent_invites.sort(
        function (a, b) {
          if (a.id > b.id) {
            return this.sort_invites ? 1 : -1;
          }
          if (a.id < b.id) {
            return this.sort_invites ? -1 : 1;
          }
          return 0;
        }.bind(this)
      );
    },
    save() {
      console.log("sharing save");
      this.$emit("save");
      this.modified_access_code.applicant = false;
      this.modified_access_code.viewer = false;
    },
    onApplicantAccessCode() {
      this.modified_access_code.applicant = true;
      this.onChange();
    },
    onViewerAccessCode() {
      this.modified_access_code.viewer = true;
      this.onChange();
    },
    async sendApplicant() {
      if (!this.email.applicant) {
        return alert("Missing applicant email address");
      }
      if (!this.$helpers.validEmail(this.email.applicant)) {
        return alert("Invalid applicant email address");
      }
      try {
        this.sending = true;
        await this.$api.post(`/user/invite/applicant`, {
          portal_id: this.item.id,
          email: this.email.applicant,
          access_code: this.item.settings.applicants.access_code,
        });

        this.sent.applicant = true;
        this.email.applicant = "";
        this.loadSent();
        setTimeout(
          function () {
            this.sent.applicant = false;
          }.bind(this),
          1000
        );
      } catch (ex) {
        alert(ex.error);
      }
      this.sending = false;
    },
    async sendViewer() {
      if (!this.email.viewer) {
        return alert("Missing viewer email address");
      }
      if (!this.$helpers.validEmail(this.email.viewer)) {
        return alert("Invalid viewer email address");
      }
      try {
        this.sending = true;
        await this.$api.post(`/user/invite/viewer`, {
          portal_id: this.item.id,
          email: this.email.viewer,
          access_code: this.item.settings.applicants.access_code,
        });
        this.loadSent();
        this.email.viewer = "";
        this.sent.viewer = true;
        setTimeout(
          function () {
            this.sent.viewer = false;
          }.bind(this),
          1000
        );
      } catch (ex) {
        alert(ex.error);
      }
      this.sending = false;
    },
    onChange() {
      this.$emit("input", this.value);
      this.$emit("change", this.value);
    },
    onCopyApplicant: function () {
      this.copied.applicant = true;
      setTimeout(
        function () {
          this.copied.applicant = false;
        }.bind(this),
        1000
      );
    },
    onErrorApplicant: function () {
      alert("Failed to copy link");
    },
    onCopyViewer: function () {
      this.copied.viewer = true;
      setTimeout(
        function () {
          this.copied.viewer = false;
        }.bind(this),
        1000
      );
    },
    onErrorViewer: function () {
      alert("Failed to copy link");
    },
  },
};
</script>

<style>
</style>